import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { withRouter } from 'react-router-dom'
import couterpart from 'counterpart';
// import ReactTablePagination from './PaginationComponent';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import {MdDeleteForever} from 'react-icons/md';
import MasterDataService from '../services/MasterDataService';

import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';

import {ICON_COLOR} from '../icon';

import { SELECTED_WORKORDER_IDX } from '../constants';

class ProductListViewAdmin extends Component {
  constructor () {
    super();
    
    this.state = {
      orderId: null,
      selectedRow: 0,
      selected: 0,
      childRefreshCount: 0,
      allStatus: [],
      selectAll: 0,
      columns : [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row =>(
            <div style={{ padding: "10px"}}>{row.index + 1}</div>
          )
        },          
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selected[original.id] === true}
                onChange={() => this.toggleRow(original.id)}
              /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        },
        {
          Header: couterpart.translate('work_order_no'),
          accessor: 'workOrderNo',
          width: 150,
          Cell: row =>(
            this.linkToDetails(row)
          )
        },{
          Header: couterpart.translate('work_order_code'),
          accessor: 'sku',
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        },{           
          Header: couterpart.translate('shop_pcode'),
          accessor: 'fullPCode',
          filterable: false,
          sortMethod: (a, b) => {
            let idx1 = a.indexOf('_')
            let a1 = a.substring(1, idx1);

            let idx2 = b.indexOf('_')
            let a2 = b.substring(1, idx2);
            return parseInt(a1) > parseInt(a2) ? 1 : -1;
          }                       
        },{
          Header: couterpart.translate('work_order_urgent_level'),
          accessor: 'isUrgentByCustomer',
          width: 50,
          Cell: row => {
            row.styles['color'] = row.value === 1 ? 'red' : 'black';
            return row.value === 1 ? 'X' : '';
          },           
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        },{          
          Header: couterpart.translate('work_order_store'),
          accessor: 'store',
          filterable: false,
          width: 100,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        },{   
          Header: couterpart.translate('work_order_status'),
          accessor: 'status',
          width: 100,
          Cell: props => this.getStatusDescription(props.value)
        }, {
          Header: couterpart.translate('work_order_status_len'),
          accessor: 'lenStatus',
          width: 100,
          Cell: ({ original }) => WorkOrderUtil.getLenStatusDescription2(original)
        },{          
          Header: couterpart.translate('work_order_status_da'),
          accessor: 'daStatus',
          width: 100,
          Cell: ({ original }) => WorkOrderUtil.getDaStatusDescription2(original)
        },{          
          Header: couterpart.translate('customer_country'),
          accessor: 'shopToCountry',
          width: 70          
        },{          
          Header: couterpart.translate('ship_to'),
          accessor: 'shipTo',
          width: 70
        },{
          Header: couterpart.translate('item_assigned_to'),
          accessor: 'designer',
          filterable: false,
          sortable: true,
          width: 70
        },{
            Header: couterpart.translate('work_order_ckExportFile'),
            accessor: 'ckExportFile',
            sortable: false,
            width: 150
        },{
          Header: couterpart.translate('work_order_order_date'),
          accessor: 'orderDate',
          filterable: false,
          width: 120          
        },{
          Header: couterpart.translate('work_order_prod_deadline'),
          accessor: 'prodDeadlineTs',
          filterable: false,
          width: 120
        },{           
          Header: couterpart.translate('work_ngay_nhap_lieu'),
          accessor: 'ngayNhapLieuTs',
          filterable: false,
          width: 120                   
        },{
          Header: couterpart.translate('work_order_worker'),
          accessor: 'workerFullName',
          filterable: false,
          width: 70,
          Cell:  ({ original }) => {
            return this.getAssignedWorkers(original)
          }
        }, {
          Header: couterpart.translate('wo_donmua'),
          accessor: 'donMua',
          filterable: false,
          width: 100
        }, {
          Header: couterpart.translate('wo_hangiaomua'),
          accessor: 'hanGiaoMua',
          filterable: false,
          width: 150
        },{
          Header: couterpart.translate('item_type'),
          accessor: 'type',
          filterable: false,
          width: 50
        },{
          Header: couterpart.translate('wo_semi'),
          accessor: 'semi',
          filterable: false,
          width: 50
        },{                     
            Header: couterpart.translate('work_order_images'),
            accessor: 'action',
            width: 100,
            show: true,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                  { this.renderImages(row.original) }
              </div>
            )
        },{        
          Header: couterpart.translate('ship_code'),
          accessor: 'shipCode',
          filterable: false,
          width: 150,
        },{
          Header: couterpart.translate('work_order_exported'),
          accessor: 'exportedAtTs',
          filterable: false,
          width: 120
        },{
          Header: couterpart.translate('work_order_productive_at'),
          accessor: 'exportedCkAtTs',
          filterable: false,
          width: 120
        },{
          Header: couterpart.translate('work_order_productive_redo'),
          accessor: 'weight',
          filterable: false,
          width: 150                    
        },{          
          Header: couterpart.translate('work_order_itype'),
          accessor: 'itemType',
          width: 70,
          Cell: props => WorkOrderUtil.getItemTypeDescription(props.value)
        },{          
          Header: couterpart.translate('work_order_tthk'),
          accessor: 'csReview',
          width: 150,
          Cell: props => this.getCSReviewDescription(props.value)
        },{                     
            Header: couterpart.translate('work_order_action'),
            accessor: 'action',
            width: 50,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                  {this.renderEditButton(row)}
              </div>
            )
        }
      ],
      columns_hide : [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row =>(
            <div style={{ padding: "10px"}}>{row.index + 1}</div>
          )
        },          
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selected[original.id] === true}
                onChange={() => this.toggleRow(original.id)}
              /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        },
        {
          Header: couterpart.translate('work_order_no'),
          accessor: 'workOrderNo',
          width: 150,
          Cell: row =>(
            this.linkToDetails(row)
          )
        },{
          Header: couterpart.translate('work_order_code'),
          accessor: 'sku',
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        },{           
          Header: couterpart.translate('shop_pcode'),
          accessor: 'fullPCode',
          filterable: false,
          sortMethod: (a, b) => {
            let idx1 = a.indexOf('_')
            let a1 = a.substring(1, idx1);

            let idx2 = b.indexOf('_')
            let a2 = b.substring(1, idx2);
            return parseInt(a1) > parseInt(a2) ? 1 : -1;
          }
        },{                     
            Header: couterpart.translate('work_order_images'),
            accessor: 'action',
            width: 100,
            show: false,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                  { this.renderImages(row.original) }
              </div>
            )                        
        },{
          Header: couterpart.translate('work_order_urgent_level'),
          accessor: 'isUrgentByCustomer',
          width: 50,
          Cell: row => {
            row.styles['color'] = row.value === 1 ? 'red' : 'black';
            return row.value === 1 ? 'X' : '';
          },           
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        },{          
          Header: couterpart.translate('work_order_store'),
          accessor: 'store',
          filterable: false,
          width: 100,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        },{   
          Header: couterpart.translate('work_order_status'),
          accessor: 'status',
          width: 100,
          Cell: props => this.getStatusDescription(props.value)
        }, {
          Header: couterpart.translate('work_order_status_len'),
          accessor: 'lenStatus',
          width: 100,
          Cell: ({ original }) => WorkOrderUtil.getLenStatusDescription2(original)
        },{          
          Header: couterpart.translate('work_order_status_da'),
          accessor: 'daStatus',
          width: 100,
          Cell: ({ original }) => WorkOrderUtil.getDaStatusDescription2(original) 
        },{          
          Header: couterpart.translate('customer_country'),
          accessor: 'shopToCountry',
          width: 70          
        },{          
          Header: couterpart.translate('ship_to'),
          accessor: 'shipTo',
          width: 70
        },{
          Header: couterpart.translate('item_assigned_to'),
          accessor: 'designer',
          filterable: false,
          sortable: true,
          width: 70
        },{
            Header: couterpart.translate('work_order_ckExportFile'),
            accessor: 'ckExportFile',
            sortable: false,
            width: 150 
        },{
          Header: couterpart.translate('work_order_order_date'),
          accessor: 'orderDate',
          filterable: false,
          width: 120
        }, {
          Header: couterpart.translate('work_order_etsy'),
          accessor: 'etsy',
          filterable: false,
          width: 120          
        },{
          Header: couterpart.translate('work_order_prod_deadline'),
          accessor: 'prodDeadlineTs',
          filterable: false,
          width: 120
        },{           
          Header: couterpart.translate('work_ngay_nhap_lieu'),
          accessor: 'ngayNhapLieuTs',
          filterable: false,
          width: 120                   
        },{
          Header: couterpart.translate('work_order_worker'),
          accessor: 'workerFullName',
          filterable: false,
          width: 70,
          Cell:  ({ original }) => {
            return this.getAssignedWorkers(original)
          }
        }, {
          Header: couterpart.translate('wo_donmua'),
          accessor: 'donMua',
          filterable: false,
          width: 100
        }, {
          Header: couterpart.translate('wo_hangiaomua'),
          accessor: 'hanGiaoMua',
          filterable: false,
          width: 150
        },{
          Header: couterpart.translate('item_type'),
          accessor: 'type',
          filterable: false,
          width: 50
        },{
          Header: couterpart.translate('wo_semi'),
          accessor: 'semi',
          filterable: false,
          width: 50           
        },{
          Header: couterpart.translate('imageURL'),
          accessor: 'imageURL',
          filterable: false,
          width: 160
        },{        
          Header: couterpart.translate('ship_code'),
          accessor: 'shipCode',
          filterable: false,
          width: 150                                                                                                                                                   
        },{
          Header: couterpart.translate('work_order_exported'),
          accessor: 'exportedAtTs',
          filterable: false,
          width: 120
        },{
          Header: couterpart.translate('work_order_productive_at'),
          accessor: 'exportedCkAtTs',
          filterable: false,
          width: 120
        },{
          Header: couterpart.translate('work_order_productive_redo'),
          accessor: 'weight',
          filterable: false,
          width: 150
        },{          
          Header: couterpart.translate('work_order_itype'),
          accessor: 'itemType',
          width: 70,
          Cell: props => WorkOrderUtil.getItemTypeDescription(props.value)                                 
        },{          
          Header: couterpart.translate('work_order_tthk'),
          accessor: 'csReview',
          width: 150,
          Cell: props => this.getCSReviewDescription(props.value)
        },{                     
            Header: couterpart.translate('work_order_action'),
            accessor: 'action',
            width: 50,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                  {this.renderEditButton(row)}
              </div>
            )
        }
      ]
    };
  }

  renderAssignedWorkerRow(assignedWorker) {
      return (
          <div classname="row">
              { assignedWorker.username + "(" + assignedWorker.department + ")" }
          </div>
      );
  }

  getAssignedWorkers(row){
      if (row.itemType <= 0){
        return(
          <>
              <div classname='col-12'>
                  {row.workerFullName }
              </div>
          </>);
      }

      if (row.assignedWorkers == null || row.assignedWorkers.length < 1){
          return "";
      }
      try {
          return(
          <>
              <div classname='col-12'>
                  {row.assignedWorkers.map(assignedWorker => this.renderAssignedWorkerRow(assignedWorker))}
              </div>
          </>
          );
      } catch (e) {

      }
      return "";
  } 

  isShow(){
    if (this.state.includeImage === 1){
      return true;
    }
    return false;
  }

  renderImages(workOrder){
    let fimage = workOrder.fimg? workOrder.fimg: undefined;
    let bimage = workOrder.bimg? workOrder.bimg: undefined;

      if (fimage === undefined && bimage === undefined){
      return (
        <>
        </>
      );
    }

    if (fimage !== undefined && bimage !== undefined){
      return (
        <>
          <img src={`data:image/jpeg;base64,${fimage}`} width="100" height="70"/>
          <img src={`data:image/jpeg;base64,${bimage}`} width="100" height="70"/>
        </>
      );
    }

    if (fimage !== undefined && bimage === undefined){
      return (
        <>
          <img src={`data:image/jpeg;base64,${fimage}`} width="100" height="70"/>
        </>
      );
    }

    if (fimage === undefined && bimage !== undefined){
      return (
        <>
          <img src={`data:image/jpeg;base64,${bimage}`} width="100" height="70"/>
        </>
      );
    }
  }

  toggleRow(id) {
		const newSelected = Object.assign({}, this.state.selected);
		newSelected[id] = !this.state.selected[id];
		this.setState({
			selected: newSelected,
			selectAll: 2
		}, () =>{
      sessionStorage.setItem(`${SELECTED_WORKORDER_IDX}`, this.state.selected);
      this.props.parentCallback(this.state.selected);
    });
	}

	toggleSelectAll() {
		let newSelected = {};

		if (this.state.selectAll === 0) {
			this.props.workOrders.forEach(x => {
				newSelected[x.id] = true;
			});
		}

		this.setState({
			selected: newSelected,
			selectAll: this.state.selectAll === 0 ? 1 : 0
		}, () =>{
      sessionStorage.setItem(`${SELECTED_WORKORDER_IDX}`, this.state.selected);
      this.props.parentCallback(this.state.selected);
    });
	}

  getStatusDescription(status){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return status;
    }    
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x =>{
      return x.status === istatus;
    });
    if (statusInfo !== undefined){
      return statusInfo.statusDescVn;
    }   
    return status;     
  }

  getCSReviewDescription(status){
    if (status === '1') {
      return 'Đã duyệt';
    }

    if (status === '0') {
      return 'Chưa duyệt';
    }

    return 'Mới import';     
  }

  renderEditButton(row){
    // const button_edit = couterpart.translate('button_edit');
    const button_delete = couterpart.translate('button_delete');
    if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
      return (<div>
              {/* <button className="myButton" onClick={() => this.handleEdit(row)}>
                <MdModeEdit color={ICON_COLOR}/>
                &nbsp;{button_edit}</button>
                &nbsp; */}
              <button className="myButton" onClick={() => this.handleDelete(row)}>
              <MdDeleteForever color={ICON_COLOR}/>
              &nbsp;{button_delete}</button>
                </div>
              );
    }else{
      return (<></>);
    }
  }

  static getDerivedStateFromProps(nextProps, state){
    // console.log('nextProps.refreshCount', nextProps.refreshCount, state.childRefreshCount)
    if (nextProps.refreshCount !== state.childRefreshCount) {
      return { childRefreshCount: nextProps.refreshCount, selected: []}
    }
  }

  componentDidMount () {
    let tmp = WorkOrderUtil.getItem('products.selectedPage');
    let iSelectPage = 0;
    if (tmp !== undefined) {
      iSelectPage = parseInt(tmp);
    }
    MasterDataService.retrieveAllStatus().then(data => {
      this.setState({ allStatus:  data, selected: []}, () => {
        let selected = WorkOrderUtil.getItem('products.selectedRow') ? parseInt(WorkOrderUtil.getItem('products.selectedRow')) : 0;
        console.log('products',selected);
        this.setState({selectedRow: selected, selectedPage: iSelectPage })
      })     
    });

    const sortedId = WorkOrderUtil.getItem('products.sortedId');
    const sortedDesc = WorkOrderUtil.getItem('products.sortedDesc');
    this.setState({
      sortedId: sortedId,
      sortedDesc: sortedDesc
    })    
  }

  handleEdit(e){
    // console.log('handleEdit', e)
    this.setState({
      selectedRow: e.viewIndex,
      workOrderId: e.original.id
    }, () => {
      WorkOrderUtil.saveItem('products.selectedRow', e.viewIndex);
      if (AuthenticationService.isAdmin()){
        this.props.history.push("/workOrders/edit/" + e.original.id + "?back=products");
        return;
      }

      if (AuthenticationService.isService()){
        this.props.history.push("/workOrders/service/" + e.original.id + "?back=products");
      }      
    })
  }

  handleDelete(e){
    if (e.type === 0){
      ToastsStore.error(couterpart.translate('msg_delete_origin_workorder'));
    }
    WorkOrderDataService.deleteCloneWorkOrder(e.original.id).then(data => {
      if (data.message === undefined){
        this.props.reloadCallback()
      }
    });
  }

  linkToDetails(row){
      return(
          <label className="label_link" href="#!" onClick={() => {this.handleEdit(row)}}>{row.original.workOrderNo}</label>
      )
  }

  compareWo(wo1, wo2) {
    let comparison = 0;
    if (wo1.type > wo2.type) {
      comparison = 1;
    } else if (wo1.type < wo2.type) {
      comparison = -1;
    }
    return comparison;
  }

  compareWo2(wo1, wo2) {
    let comparison = 0;
    if (wo1.type < wo2.type) {
      comparison = 1;
    } else if (wo1.type > wo2.type) {
      comparison = -1;
    }
    return comparison;
  }    

  render() {
    let sortedData = this.props.workOrders;
    let cols = this.state.columns_hide;
    if (this.props.includeImage === 1){
      cols = this.state.columns;
    }
    // // console.log('this.state.sortedDesc', this.state.sortedDesc);
    // if (this.state.sortedDesc === 'false'){
    //   sortedData = this.props.workOrders.sort(this.compareWo);
    //   // console.log('sortedData 1');
    // } else {
    //   sortedData = this.props.workOrders.sort(this.compareWo2);
    //   // console.log('sortedData 2');
    // }
    return (
          <div>
              <hr/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <ReactTable
                NoDataComponent={() => null} 
                // PaginationComponent={ReactTablePagination}
                previousText={"<"}
                nextText={">"}
                page={ this.state.selectedPage }
                onPageChange={(pageIndex) => {
                  this.setState({ selectedPage: pageIndex})
                  WorkOrderUtil.saveItem('products.selectedPage', pageIndex)
                }}            
                data={sortedData}
                columns={cols}
                defaultPageSize = {20}
                showPageSizeOptions = {true}
                pageSizeOptions = {[3, 5, 10, 20]}
                getTrProps={(state, rowInfo, column) => { 
                  if (rowInfo && rowInfo.row) {
                    return {
                      onClick: (e) => {
                        this.setState({
                          selectedRow: rowInfo.index,
                          workOrderId: rowInfo.original.id
                        }, () => {
                          WorkOrderUtil.saveItem('products.selectedRow', this.state.selectedRow);
                        })
                      },
                      style: {
                        background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                        color: rowInfo.index === this.state.selectedRow ? 'white' : 'black'
                      }
                    }
                  }else{
                    return {}
                  }
                }              
              }
              onSortedChange={(c, s) => { 
                // console.log(c) 
                WorkOrderUtil.saveItem('products.sortedId', c[0].id);
                WorkOrderUtil.saveItem('products.sortedDesc', c[0].desc);
              }}
              />
          </div>      
    )
  }
}

export default withRouter(ProductListViewAdmin);